import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "preflightruleflag"
    }}>{`PreflightRuleFlag`}</h1>
    <p>{`The flag indicating whether the rule is disabled, set for error, warning, or just informational.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RULE_IS_DISABLED`}</strong>{` = 1699890274`}</p>
      <p parentName="blockquote">{`Rule is currently disabled.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RETURN_AS_ERROR`}</strong>{` = 1699890546`}</p>
      <p parentName="blockquote">{`Treat as error if rule check failed.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RETURN_AS_WARNING`}</strong>{` = 1699893879`}</p>
      <p parentName="blockquote">{`Treat as warning if rule check failed.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RETURN_AS_INFORMATIONAL`}</strong>{` = 1699893865`}</p>
      <p parentName="blockquote">{`Treat as information only if rule check failed.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      